export type TABLE_LOADER_OPTIONS = {
  testId?: string;
  filtersCount?: number;
  hideSearchBar?: boolean;
  hideFilters?: boolean;
  hideActions?: boolean;
  hideHeader?: boolean;
  columnsCount?: number;
  shouldRightAlignLastCol?: boolean;
  columnsWidth?: string;
  rowsCount?: number;
};

export const DEFAULT_COLUMNS_COUNT = 7;

export const DEFAULT_ROWS_COUNT = 8;
